import { render, staticRenderFns } from "./IGDRegist.vue?vue&type=template&id=2ac5552a&scoped=true"
import script from "./IGDRegist.vue?vue&type=script&lang=js"
export * from "./IGDRegist.vue?vue&type=script&lang=js"
import style0 from "./IGDRegist.vue?vue&type=style&index=0&id=2ac5552a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac5552a",
  null
  
)

export default component.exports